import { List, Map } from 'immutable';

export * from './main';
import {
  Language,
} from './main';

import {
  EN,
  ES,
  ID,
  IT,
  JA,
  KO,
  PT_BR,
  RU,
  TH,
  TLH,
  TR,
  VI,
  ZH_HANS,
  ZH_HANT,
} from './constants';

// More readable constant names
export const BRAZILIAN_PORTUGUESE = PT_BR;
export const ENGLISH              = EN;
export const INDONESIAN           = ID;
export const ITALIAN              = IT;
export const JAPANESE             = JA;
export const KLINGON              = TLH;
export const KOREAN               = KO;
export const RUSSIAN              = RU;
export const SIMPLIFIED_CHINESE   = ZH_HANS;
export const SPANISH              = ES;
export const THAI                 = TH;
export const TRADITIONAL_CHINESE  = ZH_HANT;
export const TURKISH              = TR;
export const VIETNAMESE           = VI;

// The order for the ranked languages is important since it determines what order they
// appear in when someone uses #getLanguageRank
const RANKED_LANGUAGES = List([
  EN,
  JA,
  KO,
  TH,
  ZH_HANT,
  ES,
  ID,
  IT,
  PT_BR,
  RU,
  ZH_HANS,
  TR,
  VI,
  TLH,
]);

export const getLanguageRank = (id: Language): number => (
  RANKED_LANGUAGES.indexOf(id)
);

/* There is a test to assert that ever language from ALL_LANGUAGES is represented in the RANKED_LANGUAGE list.
 * As of the time of writing this comment, EDITOR_LANGUAGES is just an alias of ALL_LANGUAGES, but the distinction
 * exisits to help people understand the intention of the various word lists.
 */
export const EDITOR_LANGUAGES = RANKED_LANGUAGES;
export const USER_LANGUAGES = RANKED_LANGUAGES.filter(({ id }) => id !== KLINGON.id);

/*
  ALL_LANGUAGES includes Klingon to allow editors and testers view/edit/test in Klingon.
  SUPPORTED_LANGUAGES is used for the end-user facing views. Klingon should not appear for students and teachers.
*/

export const USER_LANGUAGES_BY_ID =
  Map(USER_LANGUAGES.map<[string, Language]>(language => [language.id, language]));

export default USER_LANGUAGES;
